import React, { Component } from 'react';
import { Col, Card, CardBody, Row, Collapse, Button } from 'reactstrap';
import { connect } from 'react-redux';
import VariableFieldsForm from './VariableFileds/index';
import AggregateFieldsForm from './AggregateFileds/index';
import LevelOneKeyFieldSelect from './LevelOneKeyField/index';
import LevelTwoKeyFieldSelect from './LevelTwoKeyField/index';
import PaymentRiskGradeForm from './PaymentRiskGrade/index';
import Modal from '../../../../components/UI/Modal/Modal';
import { toast } from 'react-toastify';
import { saveCreditWorthiness, fetchGlobalConfiguration, fetchVariablePredefined, fetchAggregatePredefined } from '../../action';
import { fetchAggregateTypes, fetchAggregateDirections, fetchDataTypes, fetchRiskgradeCategory } from '../../../../components/Services/action';
import { AGGREGATE_FIELDS, VARIABLE_FIELDS, KEY_FIELDS, VARIABLE, AGGREGATE, PAYMENT_RISK_GRADE } from './constants';
import { checkVariableFieldForm, creditWorthinessDropdownOptions, checkAggregateFieldForm, createRequestBody, setKeyField, setVariableData, setAggregateData, setPredefinedType, validatePaymentRiskGarde, variableEnumeratedData, setPaymentRiskGrade } from './helper.js';
import MultiSelect from '../../../../components/ReusableComponents/MultiSelect/index';
import { CREATE } from '../../../../constants';
class CreditWorthinessGlobalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            variableFieldToggleFlag: false,
            aggregateFieldToggleFlag: false,
            keyFieldToggleFlag: false,
            paymentRiskGradeToggleFlag: false,
            variableField: [],
            variableFieldInitialData: [],
            creditWorthinessDropdown: [],
            variableFieldValidationFlag: false,
            aggregateFieldValidationFlag: false,
            aggregateField: [],
            aggregateFieldInitialData: [],
            variablePredefinedData: [],
            aggregatePredefinedData: [],
            levelOneKeyFields: [],
            cugLevelOneKeyFields: [],
            levelTwoKeyFields: [],
            cugLevelTwoKeyFields: [],
            paymentRiskGrade: [],
            paymentRiskGradeInitialValue: [],
            paymentRiskGradeValidationFlag: false
        }
    }
    componentDidMount() {
        this.props.getAggregateTypes();
        this.props.getAggregateDirections();
        this.props.getDataTypes();
        this.props.fetchGlobalConfiguration();
        this.props.getAggregatePredfinedField();
        this.props.getVariablePredefined();
        this.props.fetchRiskgradeCategory();

    }

    filterKeyFields = (item) => {
        let validFieldNames = this.state.variableField.filter(x => !item || x.fieldName !== item.fieldName).map(x => x.fieldName);
        validFieldNames = validFieldNames.concat(this.state.aggregateField.filter(x => !item || x.fieldName !== item.fieldName).map(x => x.fieldName), this.state.variablePredefinedData.filter(x => !item || x.fieldName !== item.fieldName).map(x => x.fieldName), this.state.aggregatePredefinedData.filter(x => !item || x.fieldName !== item.fieldName).map(x => x.fieldName));
        const levelOneKeyFields = this.state.levelOneKeyFields.filter(x => validFieldNames.includes(x.fieldName));
        const levelTwoKeyFields = this.state.levelTwoKeyFields.filter(x => validFieldNames.includes(x.fieldName));
        const cugLevelOneKeyFields = this.state.cugLevelOneKeyFields.filter(x => validFieldNames.includes(x.fieldName));
        const cugLevelTwoKeyFields = this.state.cugLevelTwoKeyFields.filter(x => validFieldNames.includes(x.fieldName));
        this.setState({
            levelOneKeyFields: levelOneKeyFields,
            levelTwoKeyFields: levelTwoKeyFields,
            cugLevelOneKeyFields: cugLevelOneKeyFields,
            cugLevelTwoKeyFields: cugLevelTwoKeyFields
        });
    }

    componentDidUpdate(prevProps) {
        const { variableFormData, aggregateFormData } = this.props;
        if (this.props.cugPageType !== prevProps.cugPageType) {
            this.props.fetchGlobalConfiguration()
        }
        if (prevProps.variableFormData) {
            if (prevProps.variableFormData.values.variableFields !== variableFormData.values.variableFields) {
                let variableFormValidationFlag = checkVariableFieldForm(variableFormData.values.variableFields);
                if (variableFormValidationFlag) {
                    this.setState({
                        variableField: setVariableData(variableFormData.values.variableFields),
                        variableFieldValidationFlag: variableFormValidationFlag,
                        aggregateFieldToggleFlag: true,
                        creditWorthinessDropdown: creditWorthinessDropdownOptions(variableFormData.values.variableFields),
                        keyFieldToggleFlag: false
                    })
                } else {
                    this.setState({
                        variableFieldValidationFlag: variableFormValidationFlag,
                    })
                }

            }
        }
        if (prevProps.aggregateFormData !== aggregateFormData) {
            let aggregateFormValidationFlag = checkAggregateFieldForm(aggregateFormData.values.aggregateFields);
            if (aggregateFormValidationFlag) {
                this.setState({
                    aggregateField: setAggregateData(aggregateFormData.values.aggregateFields),
                    aggregateFieldValidationFlag: aggregateFormValidationFlag,
                    keyFieldToggleFlag: false
                })
            } else {
                this.setState({
                    aggregateFieldValidationFlag: aggregateFormValidationFlag,
                    keyFieldToggleFlag: false
                })
            }

        }
        if (prevProps.paymentRiskGradeForm !== this.props.paymentRiskGradeForm) {
            let riskGradeFlag = validatePaymentRiskGarde(this.props.paymentRiskGradeForm.values.riskGrades)
            if (riskGradeFlag) {
                this.setState({
                    paymentRiskGrade: this.props.paymentRiskGradeForm.values.riskGrades,
                    paymentRiskGradeValidationFlag: riskGradeFlag
                })
            } else {
                this.setState({
                    paymentRiskGradeValidationFlag: riskGradeFlag
                })
            }
        }
        if (prevProps.createGlobalConfig !== this.props.createGlobalConfig) {
            toast.success(
                <div>
                    Global Configuration Created Successfully.
                </div>
            );
            this.props.fetchGlobalConfiguration()
            this.props.history.push(`./../edit`)
        }
        if (prevProps.globalConfigData !== this.props.globalConfigData) {

            if (this.props.globalConfigData.data.fields && this.props.globalConfigData.data.fields.length > 0) {
                this.setState({
                    variableFieldInitialData: (this.props.globalConfigData.data.fields) ? variableEnumeratedData(this.props.globalConfigData.data.fields) : '',
                    aggregateFieldInitialData: (this.props.globalConfigData.data.aggregateFields) ? this.props.globalConfigData.data.aggregateFields : [],
                    levelTwoKeyFields: (this.props.globalConfigData.data.levelTwoKeyFields) ? this.props.globalConfigData.data.levelTwoKeyFields : [],
                    cugLevelTwoKeyFields: (this.props.globalConfigData.data.cugLevelTwoKeyFields) ? this.props.globalConfigData.data.cugLevelTwoKeyFields : [],
                    variableFieldToggleFlag: true,
                    levelOneKeyFields: (this.props.globalConfigData.data.levelOneKeyFields) ? this.props.globalConfigData.data.levelOneKeyFields : [],
                    cugLevelOneKeyFields: (this.props.globalConfigData.data.cugLevelOneKeyFields) ? this.props.globalConfigData.data.cugLevelOneKeyFields : [],
                    paymentRiskGradeInitialValue: setPaymentRiskGrade(this.props.globalConfigData.data.riskGrades),
                    paymentRiskGradeValidationFlag: true
                })
                if (this.props.cugPageType === CREATE) {
                    this.props.history.push(`./../edit`)
                }
            }
        } else if (prevProps.globalConfigDataFailure !== this.props.globalConfigDataFailure) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;{(this.props.globalConfigDataFailure.response && this.props.globalConfigDataFailure.response.data) ? this.props.globalConfigDataFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
        }

        if (this.props.variablePredefinedData !== prevProps.variablePredefinedData) {
            let tempPredefinedData = setPredefinedType(this.props.variablePredefinedData, VARIABLE);
            this.setState({
                variablePredefinedData: tempPredefinedData
            })
        }
        if (this.props.aggregatePredefinedData !== prevProps.aggregatePredefinedData) {
            let tempPredefinedData = setPredefinedType(this.props.aggregatePredefinedData, AGGREGATE);
            this.setState({
                aggregatePredefinedData: tempPredefinedData
            })
        }
    }

    handleSaveGlobalConfig = () => {
        if (this.state.variableFieldValidationFlag && this.state.paymentRiskGradeValidationFlag) {
            let requestBody = createRequestBody(this.state.variableField, this.state.aggregateField, this.state.levelTwoKeyFields, this.state.cugLevelTwoKeyFields, this.state.paymentRiskGrade, this.state.levelOneKeyFields,
                this.state.cugLevelOneKeyFields)
            if (!this.state.aggregateFieldValidationFlag) {
                requestBody.aggregateFields = []
            }
            this.props.saveCreditWorthiness(requestBody);
        } else {
            if (!this.state.variableFieldValidationFlag) {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Required fields in &#34;Variable Fields&#34; are missing.
                    </div>
                );
            }
            if (!this.state.paymentRiskGradeValidationFlag) {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Required fields in &#34;Payment Risk Grades&#34; are missing.
                    </div>
                );
            }
        }
    }
    levelOneKeySelect = (data) => {
        this.setState({
            levelTwoKeyFields: setKeyField(data)
        })
    }

    levelTwoCugKeySelect = (data) => {
        this.setState({
            cugLevelTwoKeyFields: setKeyField(data)

        })
    }
    toggleFields = (field) => {
        switch (field) {
            case 'AGGREGATE_FIELDS':
              this.setState(prevState => ({
                aggregateFieldToggleFlag: !prevState.aggregateFieldToggleFlag,
              }));
              break;
            case 'VARIABLE_FIELDS':
              this.setState(prevState => ({
                variableFieldToggleFlag: !prevState.variableFieldToggleFlag,
              }));
              break;
            case 'KEY_FIELDS':
              this.setState(prevState => ({
                keyFieldToggleFlag: !prevState.keyFieldToggleFlag,
              }));
              break;
            case 'PAYMENT_RISK_GRADE':
              this.setState(prevState => ({
                paymentRiskGradeToggleFlag: !prevState.paymentRiskGradeToggleFlag,
              }));
              break;
            default:
              // No action needed for default case
              break;
          }
    }
    selectedLevelOneCallback = (data) => {
        this.setState({
            levelOneKeyFields: data
        })
    }
    selectedCugLevelOneCallback = (data) => {
        this.setState({
            cugLevelOneKeyFields: data
        })
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Global Configuration</h4>
                </div>
                <Card className="mb-70 correspondent-onboarding">
                    <CardBody>
                        <Row>
                            <Col xs="24" className="border-right" style={{ marginBottom: "1%" }}>
                                <article className="collapse-company-details">
                                    <div data-target="#collapse1" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={() => this.toggleFields(VARIABLE_FIELDS)} >
                                        <h5>Variable Fields</h5>
                                        <i></i>
                                    </div>
                                </article>
                                <Collapse id="collapse1" isOpen={this.state.variableFieldToggleFlag}>
                                    <VariableFieldsForm
                                        variablePredefinedData={this.state.variablePredefinedData}
                                        variableFiledTypeDropdownOptions={this.props.dataTypes}
                                        variableFieldInitialData={this.state.variableFieldInitialData}
                                        refreshKeyFields={this.filterKeyFields} />
                                </Collapse>
                            </Col>
                            <Col xs="24" className="border-right" style={{ marginBottom: "1%" }}>
                                <article className="collapse-company-details">
                                    <div data-target="#collapse2" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={() => this.toggleFields(AGGREGATE_FIELDS)} >
                                        <h5>Aggregate Fields</h5>
                                        <i></i>
                                    </div>
                                </article>
                                <Collapse id="collapse2" isOpen={this.state.aggregateFieldToggleFlag}>
                                    <AggregateFieldsForm
                                        aggregatePredefinedData={this.state.aggregatePredefinedData}
                                        aggregateFieldDisable={this.state.variableFieldValidationFlag}
                                        aggregateFieldType={this.props.aggregateTypes}
                                        creditWorthinessDropdownoptions={this.state.creditWorthinessDropdown}
                                        aggregateFieldDirection={this.props.aggregateDirections}
                                        aggregateFieldInitialData={this.state.aggregateFieldInitialData}
                                        refreshKeyFields={this.filterKeyFields} />
                                    {/* // aggregateFormData={this.state.aggregateField} */}
                                </Collapse>
                            </Col>
                            <Col xs="24" className="border-right" style={{ marginBottom: "1%" }}>
                                <article className="collapse-company-details">
                                    <div data-target="#collapse4" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={() => this.toggleFields(KEY_FIELDS)}>
                                        <h5>Key Fields</h5>
                                        <i></i>
                                    </div>
                                </article>
                                <Collapse id="collapse3" isOpen={this.state.keyFieldToggleFlag}>
                                    <Row>
                                        <Col xs="12">
                                            <div style={{ marginBottom: '5%' }}>
                                                <h4>Level 1 (Corporate)</h4>
                                                <MultiSelect id='creditWorthiness' data={(this.state.variableField).concat(this.state.aggregateField, this.state.variablePredefinedData, this.state.aggregatePredefinedData)} selected={this.selectedLevelOneCallback} selectedValue={this.state.levelOneKeyFields} />
                                            </div>
                                            <div>
                                                <h4>Level 2 (Corporate)</h4>
                                                <LevelOneKeyFieldSelect data={(this.state.variableField).concat(this.state.aggregateField, this.state.variablePredefinedData, this.state.aggregatePredefinedData)} selectedData={this.state.levelTwoKeyFields} levelOneKeySelectCallback={this.levelOneKeySelect} />
                                            </div>

                                        </Col>
                                        <Col xs="12">
                                            <div style={{ marginBottom: '5%' }}>
                                                <h4>Level 1 (CUG)</h4>
                                                <MultiSelect id='creditWorthiness' data={(this.state.aggregateField).concat(this.state.aggregatePredefinedData)} selected={this.selectedCugLevelOneCallback} selectedValue={this.state.cugLevelOneKeyFields} />
                                            </div>
                                            <div>
                                                <h4>Level 2 (CUG)</h4>
                                                <LevelTwoKeyFieldSelect data={(this.state.aggregateField).concat(this.state.aggregatePredefinedData)} selectedData={this.state.cugLevelTwoKeyFields} levelTwoKeySelectCallback={this.levelTwoCugKeySelect} />
                                            </div>
                                        </Col>
                                    </Row>
                                </Collapse>
                            </Col>
                            <Col xs="24" className="border-right" style={{ marginBottom: "1%" }}>
                                <article className="collapse-company-details">
                                    <div data-target="#collapse2" color="primary" className="d-flex justify-content-between collapse-header collapsed header-blue p-3 mb-3" onClick={() => this.toggleFields(PAYMENT_RISK_GRADE)} >
                                        <h5>Payment Risk Grades</h5>
                                        <i></i>
                                    </div>
                                </article>
                                <Collapse id="collapse2" isOpen={this.state.paymentRiskGradeToggleFlag}>
                                    <PaymentRiskGradeForm
                                        riskLevels={this.props.riskLevels}
                                        initialData={this.state.paymentRiskGradeInitialValue} />
                                    {/* // aggregateFormData={this.state.aggregateField} */}
                                </Collapse>
                            </Col>
                        </Row>
                        <footer className="bg-light footer w-90 text-center">
                            <Button color="primary" disabled={this.state.onboardingValidationFlag} onClick={this.handleSaveGlobalConfig}>
                                Save
                    </Button>
                        </footer>
                    </CardBody>
                </Card>
                <Modal show={this.state.showModal} className='Modal' >
                    {this.state.body}
                </Modal>
            </Col>


        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    variablePredefinedData: state.globalConfiguration.variablePredefinedSuccess,
    aggregatePredefinedData: state.globalConfiguration.aggregatePredefinedSuccess,
    variableFormData: state.form.VariableFieldsForm,
    aggregateFormData: state.form.AggregateFieldsForm,
    paymentRiskGradeForm: state.form.PaymentRiskGradeForm,
    aggregateTypes: state.commonReducer.aggregateTypes,
    aggregateDirections: state.commonReducer.aggregateDirections,
    dataTypes: state.commonReducer.dataTypes,
    createGlobalConfig: state.globalConfiguration.createGlobalConfigSuccess,
    createGlobalConfigFailure: state.globalConfiguration.createGlobalConfigFailure,
    globalConfigData: state.globalConfiguration.globalConfigData,
    globalConfigDataFailure: state.globalConfiguration.globalConfigDataFailure,
    riskLevels: state.commonReducer.riskLevels
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchRiskgradeCategory: () => { dispatch(fetchRiskgradeCategory()); },
    saveCreditWorthiness: (data) => { dispatch(saveCreditWorthiness(data)) },
    fetchGlobalConfiguration: () => { dispatch(fetchGlobalConfiguration()) },
    getAggregateTypes: () => { dispatch(fetchAggregateTypes()) },
    getAggregateDirections: () => { dispatch(fetchAggregateDirections()) },
    getDataTypes: () => { dispatch(fetchDataTypes()) },
    getAggregatePredfinedField: () => { dispatch(fetchAggregatePredefined()) },
    getVariablePredefined: () => { dispatch(fetchVariablePredefined()) }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreditWorthinessGlobalComponent);

